import React from 'react'
import Image from 'next/image'

import { Text } from '@wartek-id/text-v1'

interface PelaksanaanPraktikKinerjaAppealCardProps
  extends React.HTMLAttributes<HTMLDivElement> {
  imageSrc: string
  title: string
  subtitle: string
}

export default function PelaksanaanPraktikKinerjaAppealCard({
  imageSrc,
  title,
  subtitle,
  ...props
}: PelaksanaanPraktikKinerjaAppealCardProps) {
  return (
    <div
      className="flex gap-6 p-3 border rounded-md border-orange-40 bg-surface-warning-subdued"
      {...props}
    >
      <Image
        src={imageSrc}
        className="grayscale"
        width={64}
        height={64}
        alt=""
      />
      <div className="flex items-center justify-between flex-1 gap-1">
        <div className="flex flex-col space-y-1">
          <Text variant="body-sm" color="critical">
            {subtitle}
          </Text>
          <Text variant="heading-sm">{title}</Text>
        </div>
      </div>
    </div>
  )
}
